import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-558935a5")

_pushScopeId("data-v-558935a5")
const _hoisted_1 = { class: "select-frame" }
const _hoisted_2 = { class: "template-list" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "❶マンガを選択してください", -1)
const _hoisted_4 = { class: "template-bg" }
const _hoisted_5 = { class: "frame-list" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "title" }, [
  /*#__PURE__*/_createVNode("p", null, "❷コマを選択してください")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "triangle-down" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "padding" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "attention" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 【ご注意】"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" 他のマンガからのコマの入れ替えを行うと"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" それまでの作業履歴がクリアされ、入れ"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" 替え前の状態に戻れなくなります。必要"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" に応じて入れ替え前に保存操作を実施"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" してください。"),
    /*#__PURE__*/_createVNode("br")
  ])
], -1)
const _hoisted_10 = { class: "thumbnail" }
const _hoisted_11 = { class: "commands" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "commands-padding" }, null, -1)
const _hoisted_13 = { class: "commands-btn" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "このコマを使用する", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TemplateThumbnailSelectFrame = _resolveComponent("TemplateThumbnailSelectFrame")
  const _component_HorizontalListSelectFrame = _resolveComponent("HorizontalListSelectFrame")
  const _component_modal = _resolveComponent("modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_modal, {
      isShow: _ctx.isShowModalInner,
      "onUpdate:isShow": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowModalInner = $event)),
      title: "入れ替えて使用するコマを選択してください",
      isLeftTitle: true,
      isFitSize: true
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_HorizontalListSelectFrame, {
              items: _ctx.templateSet,
              inPageCount: 4,
              emptyItem: _ctx.emptyTemplate,
              onUpdate: _ctx.updateTemplateList
            }, {
              default: _withId((slotProps) => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(slotProps.inPageItems, (item) => {
                  return (_openBlock(), _createBlock(_component_TemplateThumbnailSelectFrame, {
                    class: "thumbnail",
                    key: item.id,
                    item: item,
                    onDone: _ctx.selectTemplate
                  }, null, 8, ["item", "onDone"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["items", "emptyItem", "onUpdate"])
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _createVNode("div", _hoisted_10, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.twoBytwoOrder(_ctx.currentTemplate.frames), (frame, i) => {
              return (_openBlock(), _createBlock("img", {
                key: frame.id,
                src: _ctx.toResourceUrl(frame.balloonOn),
                class: {
              lt: i == 0,
              rt: i == 1,
              lb: i == 2,
              rb: i == 3,
            },
                onClick: ($event: any) => (_ctx.selectFrame(frame.order))
              }, null, 10, ["src", "onClick"]))
            }), 128))
          ]),
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode("div", _hoisted_13, [
              _createVNode("button", {
                class: "primary-button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.decision && _ctx.decision(...args)))
              }, [
                _hoisted_14
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isShow"])
  ]))
})